import { format, utcToZonedTime, getTimezoneOffset } from 'date-fns-tz';
import itLocale from 'date-fns/locale/it';
import esLocale from 'date-fns/locale/es';
import frLocale from 'date-fns/locale/fr';
import ruLocale from 'date-fns/locale/ru';
import enLocale from 'date-fns/locale/en-US';

import {
  timezonesNumeric,
  timezonesByCities,
} from '../enums/timezones';

export const getLocale = (locale) => {
  let dateFnsLocale;
  const cleanLocale = locale ? locale.split('-')[0] : 'en';
  switch (cleanLocale) {
    case 'it':
      dateFnsLocale = itLocale;
      break;
    case 'es':
      dateFnsLocale = esLocale;
      break;
    case 'fr':
      dateFnsLocale = frLocale;
      break;
    case 'ru':
      dateFnsLocale = ruLocale;
      break;
    case 'en':
      dateFnsLocale = enLocale;
      break;
    default: dateFnsLocale = enLocale;
  }

  return dateFnsLocale;
};

export const formatLocaleWithTimezone = (date, form, locale, timezone, includeTimezone) => {
  const converted = utcToZonedTime(date, timezone);
  if (includeTimezone) {
    return `${format(converted, form, { locale })} [${timezone}]`;
  }
  return format(converted, form, { locale });
};

export const formatLocale = (date, form, locale) => format(date, form, { locale });

export const getTimezoneLabelWithOffset = (timezone) => {
  const offsetInMilliseconds = getTimezoneOffset(timezone);
  const offsetInSeconds = Math.abs(offsetInMilliseconds / 1000);
  const offsetMinutes = Math.floor((offsetInSeconds / 60) % 60);
  const offsetHours = Math.floor(offsetInSeconds / 3600);
  const offsetMinutesString = offsetMinutes > 10 ? offsetMinutes : `0${offsetMinutes}`;
  const offsetHoursString = offsetHours > 10 ? offsetHours : `0${offsetHours}`;
  const offsetSignString = offsetInMilliseconds > 0 ? '+' : '-';
  let offsetString = `[${offsetSignString}${offsetHoursString}:${offsetMinutesString}]`;
  if (offsetString === '[-00:00]') offsetString = '[00:00]';
  if (timezonesNumeric.find((tz) => timezone === tz)) {
    return `GMT/UTC ${offsetString}`;
  }
  if (timezonesByCities.find((tz) => timezone === tz)) {
    return `${timezone} ${offsetString}`;
  }
  return 'unsupported Timezone';
};
